import { useUnlayerTemplatesEditorContext } from '@/components/views/UnlayerEmailsView/UnlayerTemplatesShared/UnlayerTemplatesEditorView/UnlayerTemplatesEditorContext';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from '@mui/material';
import React from 'react';

const DeleteDialog = () => {
	const { labels, dialogs, patchDialog, isDeletingTemplate, handleDeleteTemplate } =
		useUnlayerTemplatesEditorContext();

	return (
		<Dialog
			open={dialogs.delete.open}
			onClose={() => patchDialog('delete', { open: false })}
			fullWidth
			maxWidth='sm'
		>
			<DialogTitle>{labels.deleteDialogTitle}</DialogTitle>
			<DialogContent>
				<DialogContentText>{labels.deleteDialogBody}</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => patchDialog('delete', { open: false })}>Cancel</Button>
				<Button
					variant='contained'
					color='error'
					onClick={handleDeleteTemplate}
					disabled={isDeletingTemplate}
				>
					Delete
				</Button>
			</DialogActions>
		</Dialog>
	);
};
export default DeleteDialog;
